import { IControlOption } from '@cian/ui-kit';
import { IRealtyValuation, ERoomType } from '../../types/realtyValuation';

const ROOMS_OPTIONS: IControlOption[] = [
  /** Все комнатности **/
  {
    value: ERoomType.All,
    label: 'Все квартиры',
  },
  {
    value: ERoomType.OneRoom,
    label: '1-комн.',
  },
  {
    value: ERoomType.TwoRoom,
    label: '2-комн.',
  },
  {
    value: ERoomType.ThreeRoom,
    label: '3-комн.',
  },
  {
    value: ERoomType.FourRoom,
    label: '4-комн.',
  },
  {
    value: ERoomType.Studio,
    label: 'Студия',
  },
];

export const getRoomOptions = ({ priceDynamics: { charts } }: IRealtyValuation): IControlOption[] => {
  return ROOMS_OPTIONS.filter(({ value }) => {
    return charts.find(({ roomType }) => value === roomType);
  });
};
